import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=61c50282&scoped=true"
import script from "./applyForm.vue?vue&type=script&lang=js"
export * from "./applyForm.vue?vue&type=script&lang=js"
import style0 from "./applyForm.vue?vue&type=style&index=0&id=61c50282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c50282",
  null
  
)

export default component.exports